import { render, staticRenderFns } from "./Xxwh.vue?vue&type=template&id=5b7e7c22&scoped=true&"
import script from "./Xxwh.vue?vue&type=script&lang=js&"
export * from "./Xxwh.vue?vue&type=script&lang=js&"
import style0 from "./Xxwh.vue?vue&type=style&index=0&id=5b7e7c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e7c22",
  null
  
)

export default component.exports